import React, { FC } from "react";
import { Link } from "react-router-dom";

interface PostcardProps {
  link: string;
  image: string | undefined;
  name: string;
}

const Postcard: FC<PostcardProps> = ( {link, image, name}) => {
  return (
    <Link to={link} className="postcard">
      <img src={image}/>
      <div className="details">
        <span className="name">{name}</span>
      </div>
    </Link>
  )
}

const Postcards = (
  props: {
    link: string;
    searchParams?: string;
    items:any[];
  }
) => {
  const { items, link, searchParams } = props;

  const goTo = (locationId: number) => {
    var postcardLink = `/web/${link}${locationId}`;
    if(searchParams){
      postcardLink += searchParams
    }
    return postcardLink;
  }

  return (
    <div className="postcards">
      {
        items.map((item:any, index)=><Postcard key={index} link={goTo(item.id)} image={item.cover} name={item.name}/>)
      }
    </div>
  )
}

export default Postcards;